import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { useMemo } from 'react';
import {
  getPaginatedNodes,
  getPaginationTotalResults,
  toPagination,
} from './utils';
import { IpAddressInput, PaginationSort } from '../gql/graphql';

export const GET_IP_ADDRESS = graphql(`
  query getIpAddressList(
    $pagination: PaginationRequest
    $filters: IpAddressInput
    $sort: PaginationSort
  ) {
    ipAddresses(pagination: $pagination, filters: $filters, sort: $sort) {
      edges {
        node {
          uuid
          ipv4Address
          ipv4AddressDecimal
          ipv6Address
          ipv6AddressDecimal
          source
          score
        }
      }
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
        pageNumber
        pageSize
      }
    }
  }
`);
export interface IUseIpAddressListQueryArg {
  pageNumber: number;
  pageSize: number;
  sort?: PaginationSort;
  filters?: IpAddressInput;
}
export function useIpAddressListQuery({
  pageNumber,
  pageSize,
  sort,
  filters,
}: IUseIpAddressListQueryArg) {
  const { loading, data, error } = useQuery(GET_IP_ADDRESS, {
    variables: {
      pagination: toPagination(pageNumber, pageSize),
      sort,
      filters: {
        ...filters,
      },
    },
  });
  const { ipAddresses, totalIpAddresses } = useMemo(() => {
    if (loading) {
      return {
        ipAddresses: [],
        totalIpAddresses: 0,
      };
    }
    return {
      ipAddresses: getPaginatedNodes(data?.ipAddresses),
      totalIpAddresses: getPaginationTotalResults(data?.ipAddresses) ?? 0,
    };
  }, [data, loading]);

  return {
    loading,
    error,
    data,
    ipAddresses,
    totalIpAddresses,
  };
}
